"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheVisionBehindTheZen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223212" id="the-vision-behind-the-zen" className="bg-background text-foreground w-full p-6 lg:p-[10%] overflow-hidden">
            <div ref={ref} className={`flex flex-col lg:flex-row w-full min-h-[80vh] shadow-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                {}
                <div className="w-full lg:w-1/2 relative min-h-[50vh] lg:min-h-0 bg-card">
                    <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688847/img/modern_office_geometric_sculpture.png" alt="Modern geometric sculpture in a minimalist office space" className="absolute inset-0 w-full h-full object-cover opacity-90" />
                    <div className="absolute inset-0 bg-primary/10 mix-blend-overlay" />
                </div>

                {}
                <div className="w-full lg:w-1/2 bg-background text-foreground flex flex-col justify-center p-10 lg:p-20 xl:p-24">
                    <div className="max-w-xl">
                        <span className="font-mono text-sm tracking-widest uppercase mb-8 block text-primary opacity-80">
                            The Vision
                        </span>
                        <h2 className="font-default text-5xl lg:text-6xl xl:text-7xl font-bold mb-8 leading-[1.1] tracking-tighter text-foreground">
                            The Vision Behind the Zen
                        </h2>
                        <p className="font-default text-xl lg:text-2xl leading-relaxed mb-6 text-muted-foreground">
                            At DataZen, we believe that intelligence shouldn't be chaotic. Our mission is to transform complex operational data into a serene, automated flow that empowers your enterprise to scale without the friction of manual overhead.
                        </p>
                        <p className="font-default text-lg leading-relaxed mb-12 text-muted-foreground/80">By blending high-performance AI with minimalist design principles, we create environments where data doesn't just exist, it works for you, silently and efficiently.</p>
                        <div className="mb-12">
                            <span className="font-serif italic text-xl text-primary/90 block">
                                — The DataZen Leadership Team
                            </span>
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>;
}